import styled from 'styled-components'
import moment from 'moment'

import MailOutlineIcon from '@mui/icons-material/MailOutline'

const Footers = styled.footer`
  background-color: ${props => props.theme.colors.lightestGray};
  font-size: small;
  height: auto;
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: gray;
  a:visited, a:active, a:link { color: gray; } 
`;

export default function Footer() {
  return (
    <Footers>
      <p style={{ display: 'flex', gap: '5px' }}>
        <MailOutlineIcon style={{color: 'gray'}}/>
        <a href="mailto:support@akive.net">support@akive.net</a>
      </p>
      <p style={{ fontSize: 'x-small', color: 'gray', marginTop: '10px' }}>
        © {moment().format('YYYY')} Akive All rights reserved.
      </p>

      <div style={{ marginTop: '10px' }}>
        <a href="/oss-licenses">Open Source License</a> | <a href="/privacy-policy">Privacy Policy</a>
      </div>
    </Footers>
  )
}